import React from 'react';
import { BookOpen, MessageSquare } from 'lucide-react';
import { useVocabulary } from '../context/VocabularyContext';

export function ExerciseTypeSelector() {
  const { dispatch, actions } = useVocabulary();

  const handleVocabularySelect = () => {
    dispatch({ type: actions.SET_CURRENT_VIEW, payload: 'categories' });
    dispatch({ type: actions.SET_EXERCISE_TYPE, payload: 'vocabulary' });
  };

  const handleSentenceSelect = () => {
    dispatch({ type: actions.SET_CURRENT_VIEW, payload: 'sentence-categories' });
    dispatch({ type: actions.SET_EXERCISE_TYPE, payload: 'sentences' });
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="text-center">
        <h1 className="text-2xl font-bold text-gray-800 mb-2">
          Wybierz rodzaj ćwiczenia
        </h1>
        <p className="text-gray-600">
          Możesz ćwiczyć słownictwo lub tłumaczenie zdań
        </p>
      </div>

      {/* Exercise Type Cards */}
      <div className="grid md:grid-cols-2 gap-6">
        {/* Vocabulary Exercise */}
        <button
          onClick={handleVocabularySelect}
          className="p-8 bg-blue-50 hover:bg-blue-100 border-2 border-blue-200 hover:border-blue-300 rounded-xl transition-all duration-200 text-left group"
        >
          <div className="flex items-center mb-4">
            <div className="p-3 bg-blue-600 text-white rounded-lg group-hover:scale-110 transition-transform">
              <BookOpen size={24} />
            </div>
            <h3 className="text-xl font-bold text-gray-800 ml-4">
              Ćwiczenie słownictwa
            </h3>
          </div>
          <p className="text-gray-600 mb-3">
            Ucz się pojedynczych słów podzielonych według części mowy
          </p>
          <ul className="text-sm text-gray-500 space-y-1">
            <li>• Zaimki, czasowniki, rzeczowniki...</li>
            <li>• Tryb quiz i nauka</li>
            <li>• Dwukierunkowe tłumaczenie</li>
          </ul>
        </button>

        {/* Sentence Exercise */}
        <button
          onClick={handleSentenceSelect}
          className="p-8 bg-green-50 hover:bg-green-100 border-2 border-green-200 hover:border-green-300 rounded-xl transition-all duration-200 text-left group"
        >
          <div className="flex items-center mb-4">
            <div className="p-3 bg-green-600 text-white rounded-lg group-hover:scale-110 transition-transform">
              <MessageSquare size={24} />
            </div>
            <h3 className="text-xl font-bold text-gray-800 ml-4">
              Ćwiczenie zdań
            </h3>
          </div>
          <p className="text-gray-600 mb-3">
            Tłumacz całe zdania w różnych czasach gramatycznych
          </p>
          <ul className="text-sm text-gray-500 space-y-1">
            <li>• Czas teraźniejszy, przeszły, przyszły</li>
            <li>• Praktyczne zdania</li>
            <li>• Tylko polski → niemiecki</li>
          </ul>
        </button>
      </div>
    </div>
  );
}
